import { apiJson, apiVoid } from './api'

export interface AppNotification {
  id: string
  kind:
    | 'run_failed'
    | 'run_interrupted'
    | 'run_done'
    | 'needs_client'
    | 'broadcast'
    | 'memory_added'
  severity: 'info' | 'warning' | 'error'
  payload: Record<string, unknown>
  target_type: string | null
  target_id: string | null
  read_at: string | null
  created_at: string
}

export async function listNotifications(
  unreadOnly = false,
): Promise<{ items: AppNotification[]; unreadCount: number }> {
  const query = unreadOnly ? '?unread=1' : ''
  const data = await apiJson<{ items?: AppNotification[]; unread_count?: number }>(
    `/api/me/notifications${query}`,
  )
  return { items: data.items ?? [], unreadCount: data.unread_count ?? 0 }
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiVoid('/api/me/notifications/read', {
    method: 'POST',
    body: JSON.stringify({ all: true }),
  })
}

export async function deleteNotification(id: string): Promise<void> {
  await apiVoid(`/api/me/notifications/${id}`, { method: 'DELETE' })
}
